import {
  DATOS_FIJOS_AUTORIZACION,
  CODIGO_TIPO_SERVICIO_AUTORIZACION,
} from "./AutorizacionConstant";

export const getNombreProcedimiento = (procedimiento) => {
  const { nombreCobertura, cobertura } = procedimiento;
  return nombreCobertura ? `(${cobertura}) ${nombreCobertura}` : cobertura;
};

export const getTipoServicioTipoCobertura = (tipoServicio) => {
  return Number(tipoServicio + DATOS_FIJOS_AUTORIZACION.CODIGO_TIPO_COBERTURA);
};

export const getObjetoAutorizacion = (numeroAutorizacion) => {
  const fragmentosAutorizacion = numeroAutorizacion?.split("-");

  if (fragmentosAutorizacion?.length === 4) {
    return {
      anio: fragmentosAutorizacion[0],
      compania: fragmentosAutorizacion[1],
      ramo: fragmentosAutorizacion[2],
      secuencial: fragmentosAutorizacion[3],
    };
  }

  return null;
};

export const desfragmentarCodigoAutorizacion = (codigo) => {
  // Verificar si el código tiene el formato correcto, ejemplo P94-5017941 o H95-5017935
  const regex = /^[PH]\d+-\d+$/;
  if (!regex.test(codigo)) {
    return null;
  }

  // Extraer los valores necesarios del código
  const compania = codigo[0] === "P" ? 96 : 30;
  const ramo = parseInt(codigo.substring(1, codigo.indexOf("-")), 10);
  const secuencial = parseInt(codigo.substring(codigo.indexOf("-") + 1), 10);

  return {
    compania,
    ramo,
    secuencial,
  };
};

export const fragmentarCodigoAutorizacion = (compania, ramo, secuencial) => {
  const primerCaracter = compania === 30 ? "H" : "P";

  const numeroAutorizacion = `${primerCaracter}${ramo}-${secuencial}`;

  return numeroAutorizacion;
};

export const getStandVirtualFullUrl = (token) => {
  return `${process.env.REACT_APP_STAND_VIRTUAL_URL}?tid=${token}&compania=${process.env.REACT_APP_COMPANY}`;
};

export const homologarCodigoTipoServicio = (codigoTipoServicio) => {
  if (
    codigoTipoServicio === CODIGO_TIPO_SERVICIO_AUTORIZACION.DIALISIS ||
    codigoTipoServicio === CODIGO_TIPO_SERVICIO_AUTORIZACION.QUIMIOTERAPIA ||
    codigoTipoServicio === CODIGO_TIPO_SERVICIO_AUTORIZACION.RADIOTERAPIA
  ) {
    return CODIGO_TIPO_SERVICIO_AUTORIZACION.ALTO_COSTO;
  }

  return codigoTipoServicio;
};

export const agruparObjetoAutorizacion = (autList) => {
  if (!autList || autList.length === 0) return null;
  if (autList.length === 1) return autList[0];

  return autList.reduce((acumulado, autorizacion, index) => {
    if (index === 0) return autorizacion;
    
    acumulado.montoPagado += Number(autorizacion.montoPagado);
    acumulado.montoReclamado += Number(autorizacion.montoReclamado);
    acumulado.nombreCobertura += `, ${autorizacion.nombreCobertura}`;
    acumulado.cobertura += `, ${autorizacion.cobertura}`;

    return acumulado;
  }, { ...autList[0] });
};